export default "__VITE_ASSET__gz$Oxxw5__"